export default __webpack_public_path__ + "static/media/kitchen5-afterB-1440w.671b16a8.avif";